export default "__VITE_ASSET__uaU$ffSh__"